import React from 'react'; 
import { useNavigate } from 'react-router-dom';

// Import images for each product
import bedImg from '../../img/beds.jpeg'; // Bed image
import covesImg from '../../img/coves1.jpeg'; // Coves image
import stopImg1 from '../../img/Stop2.jpeg'; // Stop image
import casungImg from '../../img/Casung1.jpeg'; // Casung image

const Products = () => {
  const navigate = useNavigate();
  const title = '';
  const products = [
    {
      id: 1,
      name: 'Beds',
      description: 'A refined decorative molding, smaller and less prominent than crown moldings. Used to embellish joints or surface transitions, providing a smooth and polished appearance to interior design elements.',
      image: bedImg, // Image for Beds
    },
    {
      id: 2,
      name: 'Coves',
      description: 'A decorative molding with a curved or concave shape, commonly placed at the junction between the ceiling and wall. It creates a soft, elegant transition and can enhance the visual flow of a room.',
      image: covesImg, // Image for Coves
    },
    {
      id: 3,
      name: 'Stops',
      description: 'Stops can be additional pieces used to finish off trim or joints, providing a smooth transition or visual stopping point. They act as a stop, ensuring that the door or window does not pass beyond a certain point.',
      image: stopImg1, // Image for Stops
    },
    {
      id: 4,
      name: 'Casung',
      description: 'Architectural trim or frame surrounding doors, windows, or other openings. Serves both functional and aesthetic purposes, adding definition and visual interest to architectural elements.',
      image: casungImg, // Image for Casung
    }
  ];

  const handleProductClick = (category) => {
    navigate(`/products/${category.toLowerCase()}`);
  };

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-center mb-8">{title || '\u00A0'}</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {products.map((product) => (
          <div 
            className="bg-white rounded-lg shadow-md overflow-hidden transform transition-transform duration-300 hover:scale-105 cursor-pointer flex flex-col h-full" 
            key={product.id}
            onClick={() => handleProductClick(product.name)}
          >
            <img 
              src={product.image} 
              alt={product.name} 
              className="w-full h-48 object-cover"
            />
            <div className="p-4 flex flex-col flex-grow">
              <h5 className="text-xl font-semibold mb-2 text-gray-800">{product.name}</h5>
              <p className="text-sm text-gray-600 leading-relaxed flex-grow">{product.description}</p>
            </div>
          </div>
        ))}

        {/* Informative Card */}
        <div 
          className="md:col-span-2 bg-emerald-800 rounded-lg shadow-md p-6 flex flex-col justify-between cursor-pointer hover:bg-emerald-700 transition-colors duration-300"
          onClick={handleContactClick}
        >
        <div>
          <h5 className="text-xl font-bold text-emerald-50 mb-4">Need More Information?</h5>
          <p className="text-emerald-100 mb-4">
            If you want to learn more details about our products or have any special inquiries, 
            don't hesitate to contact us. We are here to help you.
          </p>
          <p className="text-emerald-100">
            To view the full list of products, please register to obtain your access token (key).
          </p>
        </div>

          <div className="mt-4">
            <span className="text-emerald-50 font-semibold hover:underline">
              Contact Us →
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
